var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mb-16"},[_c('div',{staticClass:"text-2xl font-semibold my-4 ml-2"},[_vm._v("Reviews")]),_c('review')],1)}
var staticRenderFns = []

export { render, staticRenderFns }